import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  saveCounterRateApi,
  removeCounterRateApi,
} from "../api/csOpenIPOApi.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CounterRateSlider = (props) => {
  const [weaverRate, setWeaverRate] = useState(0);
  const [counterRate, setCounterRate] = useState(0);
  const [quoteWeaverId, setQuoteWeaverId] = useState(0);
  const [loader, setLoader] = useState("none");

  useEffect(() => {
    setQuoteWeaverId(props.quoteWeaverId);
    setCounterRate(props.counterRate);
    setWeaverRate(props.weaverRate);
  }, [props.quoteWeaverId, props.counterRate, props.weaverRate]);

  function saveCounterRate() {
    setLoader("block");
    saveCounterRateApi(quoteWeaverId, counterRate, cbCounterRate);
  }
  function cbCounterRate(data) {
    setLoader("none");
    if (data.status === "Success") {
      toast.success(data.message);
      props.getOpenIpoList();
      props.closeSlider();
    } else {
      toast.error(data.message);
      if (data.message === "You are not logged in") {
        window.location.href = window.CSURL;
      }
    }
  }
  function removeCounterRate() {
    removeCounterRateApi(quoteWeaverId, cbCounterRate);
  }

  return (
    <form className="col-sm-12 form form-horizontal" style={{marginTop:15, paddingTop:15}}>
      <ToastContainer autoClose={2000} hideProgressBar />
      <div
        style={{
          position: "fixed",
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: "50%",
          top: "50%",
          display: loader,
        }}
      >
        <img src={require("../images/loader.gif")} alt="Loader..." />
      </div>
      <div className="form-group">
        <label className="control-label col-sm-2">Weaver Rate</label>
        <div className="col-sm-1">
          <input
            type="text"
            className="form-control text-right"
            value={weaverRate}
            readOnly
          />
        </div>
      </div>
      <div className="form-group">
        <label className="control-label col-sm-2">Counter Rate</label>
        <div className="col-sm-1">
          <input
            type="text"
            className="form-control text-right"
            pattern="[0-9]+"
            value={counterRate}
            onChange={(e) => setCounterRate(e.target.value)}
          />
        </div>
      </div>
      <div className="form-group">
        <div className="col-sm-3">
          <div className="col-sm-12 pull-right">
          <div
            style={{ justifyContent: "space-evenly", display: "flex" }}
          >
            <button
              type="button"
              onClick={() => saveCounterRate()}
              className="btn btn-warning"
            >
              Save
            </button>
            <button
              type="button"
              onClick={() => removeCounterRate()}
              className="btn btn-danger"
            >
              Delete
            </button>
          </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default CounterRateSlider;
